<template>
  <span class="first:hidden">&middot;</span>
  <select
    v-model="locale"
    class="cursor-pointer disabled:cursor-wait min-h-3 disabled:text-grey text-grey hover:text-wedges-gray-900 -ms-0.5 p-0 bg-transparent"
    :style="{ width: selectWidth + 'px' }"
    :disabled="isLoading"
    @change.prevent="updateLocale"
  >
    <option v-for="(value, key) in locales" :key="key" :value="key">{{ value }}</option>
  </select>
  <span ref="hiddenSpan" aria-hidden="true" class="whitespace-nowrap absolute invisible">{{ locales[locale] }}</span>
</template>

<script>
import useCheckout from '@/Pages/Web/Components/Checkout/useCheckout.js'
// eslint-disable-next-line import/extensions
import { getActiveLanguage, setLocale } from '@/Translate'

export default {
  inject: ['cart', 'isApi', 'isPreview'],
  data() {
    return {
      locale: this.cart.locale ?? this.getUserLocale() ?? 'en',
      checkoutHandler: null,
      selectWidth: 100,
      isLoading: false,
    }
  },
  watch: {
    locale() {
      this.updateSelectWidth()
    },
  },
  mounted() {
    this.updateSelectWidth()
  },
  created() {
    this.setCheckoutHandler()

    if (this.locale !== getActiveLanguage()) {
      setLocale(this.locale)
    }
  },
  methods: {
    setCheckoutHandler() {
      this.checkoutHandler = useCheckout(this.currentStore.url_domain, this.cart, this.isApi, this.isPreview)
    },
    async updateLocale() {
      this.isLoading = true

      setLocale(this.locale)

      try {
        await this.checkoutHandler.setLocale(this.locale)
      } finally {
        this.isLoading = false
      }
    },
    updateSelectWidth() {
      this.$nextTick(() => {
        this.selectWidth = this.$refs.hiddenSpan.offsetWidth + 22
      })
    },
  },
}
</script>
